import React, { useState, useEffect } from 'react';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const Support = () => {
  const [isLoading, setIsLoading] = useState(false);
  function goBack() {
    window.history.back();
  }
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    type: 'Question about the app',
    description: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      return;
    }
    try {
      const supportresp = await fetchWithAuth(API_ENDPOINTS.USER_SUPPORT, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          reason: formData.type,
          message: formData.description,
        }),
      });

      if (!supportresp.ok) {
        throw new Error('Failed to ask support');
      }
      alert('Support request sent successfully!');
      setIsLoading(false);
      window.history.back();
    } catch (error) {
      setIsLoading(false);
      console.error('Error sending request:', error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  }, [navigate]);

  return (
    <div className="p-2" style={{ height: '100dvh' }}>
      {isLoading ? (
        <div className="lmodale">
          <div className="loverlay"></div>

          <div className="lmodalecontent">
            <Spinner animation="border" role="status" style={{ color: 'red' }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className="col-7 d-flex flex-row justify-content-between align-items-center my-2">
        <FaArrowLeftLong
          style={{ fontSize: '22px' }}
          onClick={() => goBack()}
        />
        <h2 className="m-0" style={{ color: '#D0151C', whiteSpace: 'nowrap' }}>
          Support
        </h2>
      </div>

      <form className="w-100 text-start my-2" onSubmit={handleSubmit}>
        <select
          name="type"
          value={formData.type}
          onChange={handleChange}
          className="w-100 p-2 my-2"
          style={{
            borderRadius: '5px',
            fontSize: '16px',
            border: 'solid 1px #D8D8D8',
            background: 'white',
          }}
        >
          <option value="Question about the app">Question about the app</option>
          <option value="Question about the account">
            Question about the account
          </option>
          <option value="Question about the coins">
            Question about the coins
          </option>
          <option value="Question about the purachase">
            Question about the purachase
          </option>
          <option value="Report a bug">Report a bug</option>
          <option value="Other">Other</option>
        </select>

        <label className="w-100 my-1">
          <h4
            className="mb-2"
            style={{
              background: 'linear-gradient(90deg, #CC151E 0%, #8A325D 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block',
            }}
          >
            Description
          </h4>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-100 p-2"
            maxLength={500}
            placeholder="Max 500 characters*"
            style={{
              borderRadius: '5px',
              fontSize: '16px',
              border: 'solid 1px #D8D8D8',
              minHeight: '20dvh',
            }}
          ></textarea>
          <div className="w-100 text-end">
            <span
              className="text-end w-100"
              style={{ fontSize: '12px', color: '#CC151E' }}
            >
              Character remaining: {500 - formData.description.length}
            </span>
          </div>
        </label>

        <div className="w-100 d-flex flex-row justify-content-between align-items-center my-2">
          <button
            className="col-5 p-2"
            style={{
              borderRadius: '8.699px',
              border: '1px solid #BF1B2B',
              background: 'linear-gradient(90deg, #CC151E 0%, #8A325D 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block',
            }}
            onClick={() => goBack()}
          >
            Cancel
          </button>
          <button
            className="col-5 p-2"
            style={{
              borderRadius: '8.699px',
              border: 'none',
              background:
                'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
              color: 'white',
            }}
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>

      <img src="/images/support_page.png" className="w-100 mt-2" />
    </div>
  );
};

export default Support;
